/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type OutputForm_meeting$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type NewOutputForm_meeting$ref: FragmentReference;
declare export opaque type NewOutputForm_meeting$fragmentType: NewOutputForm_meeting$ref;
export type NewOutputForm_meeting = {|
  +id: string,
  +currentAgendaItem: ?{|
    +id: string
  |},
  +$fragmentRefs: OutputForm_meeting$ref,
  +$refType: NewOutputForm_meeting$ref,
|};
export type NewOutputForm_meeting$data = NewOutputForm_meeting;
export type NewOutputForm_meeting$key = {
  +$data?: NewOutputForm_meeting$data,
  +$fragmentRefs: NewOutputForm_meeting$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NewOutputForm_meeting",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AgendaItem",
      "kind": "LinkedField",
      "name": "currentAgendaItem",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "OutputForm_meeting"
    }
  ],
  "type": "Meeting",
  "abstractKey": "__isMeeting"
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cf62d9fd582bbe3e4dcbcd1f536fde20';

module.exports = node;
